// SVG Visuals Library for Learning Module V2
// All visuals split into sub-modules for maintainability
import React from 'react';

export { C, HL, Lbl, Div } from './visuals/svgPrimitives';

import { coreVisuals } from './visuals/coreVisuals';
import { levelCardsVisuals } from './visuals/levelCardsVisuals';
import { levelCards2Visuals } from './visuals/levelCards2Visuals';
import { levelCards3Visuals } from './visuals/levelCards3Visuals';

// Merge all visual groups ? later entries override duplicates (levelCards2 is authoritative)
export const VISUALS = { ...coreVisuals, ...levelCardsVisuals, ...levelCards2Visuals, ...levelCards3Visuals };

function fallbackVisual(missingKey = 'unknown_visual') {
  const safeKey = String(missingKey || 'unknown_visual').slice(0, 28);
  return (
    <svg viewBox="0 0 200 110" className="w-full">
      <rect x="8" y="8" width="184" height="94" rx="8" fill="#f8fafc" stroke="#cbd5e1" strokeWidth="1.5" />
      <text x="100" y="40" fill="#64748b" fontSize="10" textAnchor="middle" fontFamily="sans-serif">
        Visual not available
      </text>
      <text x="100" y="58" fill="#94a3b8" fontSize="9" textAnchor="middle" fontFamily="ui-monospace,monospace">
        {safeKey}
      </text>
      <text x="100" y="78" fill="#94a3b8" fontSize="8" textAnchor="middle" fontFamily="sans-serif">
        Using generic fallback
      </text>
    </svg>
  );
}

export function getVisualComponent(visualName) {
  if (VISUALS[visualName]) return VISUALS[visualName];
  console.warn('Missing SVG visual key:', visualName);
  return fallbackVisual(visualName);
}

export default VISUALS;
